import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';

export default class SiteRoad {
    _firstDot: marietta.core.Point;

    get firstDot() { return this._firstDot; }

    set firstDot(_dot) {
      this._firstDot = _dot;
      this.updateTransforms();
    }

    _secondDot: marietta.core.Point;

    get secondDot() { return this._secondDot; }

    set secondDot(_dot) {
      this._secondDot = _dot;
      this.updateTransforms();
    }

    get roadwidth(): number {
      return this.itemInfo.dotList[this.index - 1].road_w;
    }

    set roadwidth(value: number) {
      this.itemInfo.dotList[this.index - 1].road_w = value;
    }

    get lr(): boolean {
      return this.itemInfo.dotList[this.index - 1].road_lr;
    }

    set lr(value: boolean) {
      this.itemInfo.dotList[this.index - 1].road_lr = value;
    }

    index: number;

    public spt: SVGSprite;

    roadNuri: SVGElement;

    roadDash: SVGElement;

    parent: marietta.webcad.item.Site;

    itemInfo: marietta.webcad.collection.ItemInfoCollection;

    /**
     * コンストラクタ
     * */
    constructor(parent:marietta.webcad.item.Site, id: number) {
      this.parent = parent;
      const targetNode = this.parent.roadView;
      this.itemInfo = this.parent.itemInfo;
      this.index = id;

      // ラインの作成
      const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      viewObj.setAttribute('id', `site_road_${id}`);

      this.roadNuri = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      this.roadNuri.setAttribute('id', `site_road_${id}_nuri`);
      this.roadNuri.setAttribute('fill', '#CCCCCC');
      this.roadNuri.setAttribute('width', String(marietta.webcad.util.WebCADUtil.convertMMToPix(this.roadwidth)));
      viewObj.appendChild(this.roadNuri);

      this.roadDash = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      this.roadDash.setAttribute('stroke', '#FFFFFF');
      if (this.roadwidth > 2000) {
        this.roadDash.style.setProperty('stroke-dasharray', '120 120');
      } else {
        this.roadDash.style.setProperty('stroke-dasharray', '0');
      }
      this.roadDash.style.setProperty('stroke-width', String(marietta.webcad.util.WebCADUtil.convertMMToPix(this.roadwidth) ? 9 : 0));
      viewObj.appendChild(this.roadDash);

      this.spt = new SVGSprite(viewObj);
      targetNode.appendChild(viewObj);

      // アクション
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        this.viewObj.addEventListener('touchstart', this.onMouseDownMe, { passive: false });
      } else {
        this.viewObj.addEventListener('mousedown', this.onMouseDownMe);
      }
      ua = null;
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
      if (!this.firstDot || !this.secondDot) return '';

      // 道路の描画し直し
      const distance = marietta.core.Point.distance(this.firstDot, this.secondDot);
      this.roadNuri.setAttribute('width', String(marietta.webcad.util.WebCADUtil.convertMMToPix(this.roadwidth)));
      this.roadNuri.setAttribute('height', String(distance));

      // 破線
      this.roadDash.setAttribute('x1', String(marietta.webcad.util.WebCADUtil.convertMMToPix(this.roadwidth) / 2));
      this.roadDash.setAttribute('x2', String(marietta.webcad.util.WebCADUtil.convertMMToPix(this.roadwidth) / 2));
      this.roadDash.setAttribute('y1', '0');
      this.roadDash.setAttribute('y2', String(distance));
      this.roadDash.setAttribute('stroke-width', String(marietta.webcad.util.WebCADUtil.convertMMToPix(this.roadwidth) ? 2 : 0));

      let retTransform = '';
      retTransform += `translate( ${this.firstDot.x}, ${this.firstDot.y} ) `;
      retTransform += `rotate( ${marietta.core.Point.getAngleBetween(this.firstDot, this.secondDot) - 90} ) `;
      retTransform += `scale( ${this.lr ? -1 : 1}, 1 ) `;

      this.viewObj.setAttribute('transform', retTransform);

      return retTransform;
    }

    /**
     * HTMLElementの取得
     */
    public get viewObj(): HTMLElement {
      return this.spt.element;
    }

    /**
     * ハイライト
     * */
    highlight(value: boolean) {
      if (value) {
        this.viewObj.setAttribute('stroke-width', '10');
      } else {
        this.viewObj.setAttribute('stroke-width', '0');
      }
    }

    /**
     * 反転
     */
    onMouseDownMe = () => {
      // 親がカレントになっていなければ、無視
      const groupItem = (marietta.webcad.WebCADGlobal.itemManager.currentItemGroup !== null && marietta.webcad.WebCADGlobal.itemManager.currentItemGroup !== undefined);

      // if(marietta.webcad.WebCADGlobal.itemManager.currentItem != this.parent ){
      //     return;
      // }

      if (!groupItem) {
        if (marietta.webcad.WebCADGlobal.itemManager.currentItem !== this.parent) {
          return;
        }
      }
      this.lr = !this.lr;
      this.updateTransforms();
      // 履歴
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }

    /**
     * 表示ON
     */
    show() {
      this.spt.element.style.visibility = 'visible';
    }

    /**
     * 表示ON
     */
    hide() {
      this.spt.element.style.visibility = 'hidden';
    }
}
